<template>
<div>
  <v-container>
    <p>Grupowe dodawanie dokumentów w jednym pliku:</p>
    <input type="file" style="display:none" id="fileMultiInput" />
    <v-text-field
        v-model="filename"
        @click="fileInput.click()"
        label="Plik"
        required
    ></v-text-field>

    <v-checkbox
        label="Dokumenty rozdzielone kodem kreskowym"
        v-model="barcode"
        required
    ></v-checkbox>

    <div>
      <v-btn :disabled="!file" color="green" @click="upload()">
        Dodaj
      </v-btn>
    </div>

  </v-container>
</div>
</template>

<script>
import PdfViewer from '@/components/pdf/Viewer'
import i18n from '@/plugins/vuei18n'
import Messenger from "@/plugins/Messenger";
const ALLOWED_EXTENSIONS = ['pdf','tiff','tif']

export default {
  props:['hideQueueButton'],
  components: {
    PdfViewer
  },
  computed: {

  },
  data() {
    return {
      barcode : false,
      filename : "",
      file: null,
      fileInput: {},
    }
  },
  methods: {
    isValid(file) {
      return ALLOWED_EXTENSIONS.includes(file.name.split('.').pop())
    },
    upload() {
      let formData = new FormData()
      formData.append('document', this.file)
      formData.append('barcode', this.barcode)
      this.$http.post('document/create-multi', formData).then(data =>{
        Messenger.emitSuccess("Przyjęto dokument do przetwarzania")
        this.file = null
        this.filename = ''
      }).catch(e =>{
        Messenger.emitError("Bład przy dodawaniu")
      })

    },
    onFilePicked(e){
      let files = e.target.files
      if(files && files.length == 1 && this.isValid(files[0])){
        this.filename = files[0].name
        this.file = files[0]
        return
      }
      Messenger.emitError("Bład przy dodawaniu pliku")
    },
  },
  mounted() {
    this.fileInput = document.querySelector('#fileMultiInput')
    this.fileInput.onchange = this.onFilePicked

  }
}
</script>

<style scoped>
.file-container {
  border-style: dashed;
  color: gray;
  text-align: center;
  margin-bottom: 2rem;
  height:100px;
  box-sizing: content-box;
  cursor: pointer;
}

.icon-add {
  user-select: none;
  line-height: 100px;
  font-size: 24px;
  color: gray;
  opacity: 0.4
}
</style>
